<template lang="html">
  <div :class="['rule-container',showRule ? '' : 'no-rule']">
    <h3 v-if="showRule" >——  {{ruleTitle}}  ——</h3>
    <h3 v-else >——  京东金融出品  ——</h3>
    <ul v-if="showRule">
      <li v-for="(rule,index) in ruleList">
        <span>{{index + 1}}、</span>
        <em>{{rule}}</em>
      </li>
      <li class="detail">
        <a href="https://m.jr.jd.com/mjractivity/69673-2.html" clstag="jr|keycount|sqqxl_20181016|1">查看更多详情 ></a>
      </li>
    </ul>
  </div>
</template>

<script>
import Barrage from "@/components/Barrage";
export default {
  props: ["showRule"],

  data () {
    return {
      ruleList:data_source_100001051.ruleList,
      ruleTitle:data_source_100001051.ruleTitle
    }
  },
}
</script>

<style lang="scss" scoped>
.rule-container{
  font-family: PingFang SC;
  color: #FFFFFF;
  opacity: 0.6;
  // margin-top: -25px;
  clear: both;
  text-align: center;
  padding-top: 60px;
  &.no-rule{
    padding-top: 0
  }
  h3{
    color: #fff;
    // opacity: 1;
    font-size: 30px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    text-align: center;
    margin-bottom: 30px;
    // margin-top: 42px;
  }
  ul{
    color: #fff;
    padding: 0 25px 95px 35px;
    font-size:28px;
    text-align: left;
    li{
      // opacity: 1;
      line-height: 42px;
      margin-bottom: 5px;
      // padding-bottom: 5px;
      span{
        display: block;
        float: left;
      }
      em{
        display: block;
        overflow: hidden;
      }
      &.detail{
        padding-top: 30px;
        text-align: center;
        // opacity: 1;
        a{
          color: #fff;
          // opacity: 1;
          text-decoration: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Rule/index.vue